import { m } from "@/paraglide/messages.js";

/**
 * The platform's own copy. Every string is a getter, not a string: these arrays live at module
 * scope, so a plain string would freeze whatever locale was active when the module first loaded.
 * `id` is the stable React key, so it never depends on translated text.
 */

export type Question = { id: string; question: () => string; answer: () => string };

export const questions: Question[] = [
  {
    id: "start",
    question: () => m.platform_faq_start_q(),
    answer: () => m.platform_faq_start_a(),
  },
  {
    id: "clients",
    question: () => m.platform_faq_clients_q(),
    answer: () => m.platform_faq_clients_a(),
  },
  {
    id: "page",
    question: () => m.platform_faq_page_q(),
    answer: () => m.platform_faq_page_a(),
  },
  {
    id: "payments",
    question: () => m.platform_faq_payments_q(),
    answer: () => m.platform_faq_payments_a(),
  },
  {
    id: "team",
    question: () => m.platform_faq_team_q(),
    answer: () => m.platform_faq_team_a(),
  },
  {
    id: "leave",
    question: () => m.platform_faq_leave_q(),
    answer: () => m.platform_faq_leave_a(),
  },
];
